import { useSelectedChain } from "@app/examples/ChainSelector";
import { PaginationBar } from "@components/PaginationBar";
import { CollectionCardV2 } from "@components/collection/CollectionCardV2";
import { useApi } from "@hooks/ApiHook";
import useScrollReset from "@hooks/ScrollHook";
import { useState } from "react";

function CollectionsPage() {
    useScrollReset()
    const [search, setSearch] = useState("")
    const [page, setPage] = useState(1)
    const { selectedChain } = useSelectedChain()
    const { data: collection } = useApi(api => api.collection.all({ search, page, chainId: selectedChain?.id }), [search, page, selectedChain])

    let debounceTimer: NodeJS.Timeout;
    const onSearch = (text: string) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => setSearch(text), 500);
    };

    return <>
        <main>
            <section className="relative py-24" id="collections">
                <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
                    <img src="img/gradient_light.jpg" alt="gradient" className="h-full w-full" />
                </picture>
                <div className="container">
                    <div className="js-collections-content">
                        <div className="flex flex-wrap items-center">
                            <div className="mb-8 pb-px">
                                <h1 className="pt-3 mb-2 font-display text-2xl font-medium text-jacarta-700 dark:text-jacarta-400">
                                    Explore Collections
                                </h1>
                                <p className="dark:text-gray-400 font-medium text-2xs">{collection?.totalCount ?? 0} items</p>
                            </div>

                            <div className="relative basis-3/12 ml-auto">
                                <input
                                    onChange={({ target }) => onSearch(target.value)}
                                    type="search"
                                    className="w-full rounded-2xl border border-jacarta-100 py-[0.6875rem] px-4 pl-10 text-jacarta-700 placeholder-jacarta-500 focus:ring-accent dark:border-transparent dark:bg-gray-900 dark:text-white dark:placeholder-white"
                                    placeholder="Search" />
                                <span className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                        className="h-4 w-4 fill-jacarta-500 dark:fill-white">
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path
                                            d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
                                    </svg>
                                </span>
                            </div>

                        </div>

                        <div className="tab-content">

                            <div className="tab-pane fade show active" id="view-grid" role="tabpanel" aria-labelledby="view-grid-tab">
                                <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-4 js-collections-grid">
                                    {
                                        collection?.data.map(collection => {
                                            return <CollectionCardV2 collection={collection} />
                                        })
                                    }
                                </div>
                            </div>

                        </div>

                        <div className="mt-5"></div>

                        {
                            collection && <PaginationBar
                                pagination={collection}
                                currentPage={page}
                                onPageChange={page => setPage(page)} />
                        }


                    </div>
                </div>
            </section>
        </main>
    </>
}

export default CollectionsPage;